import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="mt-auto border-t border-slate-200 bg-white">
      <div className="mx-auto max-w-7xl px-6 py-5 space-y-3">
        <div className="flex items-center justify-center">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-teal-200 bg-teal-50 px-4 py-1.5 text-xs font-medium text-teal-700">
            <svg className="h-3 w-3 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 100 20A10 10 0 0012 2z" />
            </svg>
            Vivifyer tracks activity &amp; provides general sports information — not medical advice. Always check with a qualified trainer.
          </span>
        </div>
        <div className="flex flex-col items-center justify-between gap-3 sm:flex-row">
          <p className="text-xs text-slate-400">
            © {new Date().getFullYear()} Vivifyer. All rights reserved.
          </p>
          <div className="flex items-center gap-5 text-xs font-medium text-slate-500">
            <Link to="/privacy" className="hover:text-emerald-600 transition-colors">
              Privacy Policy
            </Link>
            <span className="text-slate-300">·</span>
            <Link to="/terms" className="hover:text-emerald-600 transition-colors">
              Terms &amp; Conditions
            </Link>
            <span className="text-slate-300">·</span>
            <Link to="/contact" className="hover:text-emerald-600 transition-colors">
              Contact Us
            </Link>
            <span className="text-slate-300">·</span>
            <Link to="/download" className="hover:text-emerald-600 transition-colors">
              Download the app
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
